import React, { useState, useEffect, useCallback } from "react";
import {
  Button,
  Input,
  Spinner
} from "reactstrap";
import { Tooltip } from "react-tooltip";
import { Range, getTrackBackground, useThumbOverlap } from 'react-range';

import btnDraw from "../../assets/images/icons/whiteboard-menu-c-1.svg";
import btnCursor from "../../assets/images/icons/whiteboard-menu-c-2.svg";
import btnSearchlight from "../../assets/images/svg/searchlight.svg";
import openBottom from "../../assets/images/tool/open_bottom.svg";
import closeBottom from "../../assets/images/tool/close_bottom.svg";
import toolLeft from "../../assets/images/tool/tool-left.svg";
import toolRight from "../../assets/images/tool/tool-right.svg";
import Delete from "../../assets/images/icons/whiteboard-menu-c-3.svg";
import turnLeft from "../../assets/images/icons/whiteboard-menu-c-4.svg";
import turnRight from "../../assets/images/icons/whiteboard-menu-c-5.svg";
import grab from "../../assets/images/icons/whiteboard-menu-b-5.svg";
import pencil from "../../assets/images/icons/whiteboard-menu-b-1.svg";
import highlighter from "../../assets/images/icons/whiteboard-menu-b-2.svg";
import eraser from "../../assets/images/icons/whiteboard-menu-b-3.svg";
import pattern from "../../assets/images/icons/whiteboard-menu-b-4.svg";
import line from "../../assets/images/icons/whiteboard-menu-c-6.svg";
import arrow from "../../assets/images/icons/whiteboard-menu-c-7.svg";
import rect from "../../assets/images/icons/whiteboard-menu-c-8.svg";
import ellipse from "../../assets/images/icons/whiteboard-menu-c-9.svg";
import rectFill from "../../assets/images/icons/whiteboard-menu-c-10.svg";
import ellipseFill from "../../assets/images/icons/whiteboard-menu-c-11.svg";
import coverCircle from "../../assets/images/tool/cover-circle.svg";
import coverLine from "../../assets/images/tool/cover-line.svg";
import coverRect from "../../assets/images/tool/cover-rect.svg";
import coverReverse from "../../assets/images/tool/reverse.svg";
import toolSize from "../../assets/images/tool/tool-size.svg";

import widgetBackground from "../../assets/images/icons-component/background.png";
import widgetRandomName from "../../assets/images/icons-component/random.png";
import widgetCard from "../../assets/images/icons-component/card.png";
import widgetQrCode from "../../assets/images/icons-component/qrcode.png";
import widgetImage from "../../assets/images/icons-component/image.png";
import widgetText from "../../assets/images/icons-component/text.png";
import widgetRead from "../../assets/images/icons-component/read.png";
import widgetTimer from "../../assets/images/icons-component/timer.png";
import widgetClock from "../../assets/images/icons-component/clock.png";
import widgetCalendar from "../../assets/images/icons-component/calendar.png";
import widgetTimeTable from "../../assets/images/icons-component/timetable.png";
import widgetGroupMaker from "../../assets/images/icons-component/group.png";
import widgetStopwatch from "../../assets/images/icons-component/stopwatch.png";
import widgetEmbed from "../../assets/images/icons-component/embed.png";
import widgetVideoTimeline from "../../assets/images/icons-component/video.png";
import widgetEventCountdown from "../../assets/images/icons-component/countdown.png";
import widgetHyperlink from "../../assets/images/icons-component/hyperlink.png";
import widgetWorks from "../../assets/images/icons-component/works.png";
import widgetMindMap from "../../assets/images/svg/mindmap.svg";


const BottomToolbar = (props: any) => {
  const {
    toolSwitch,
    switchToggle,
    jobToggle,
    drawSetting,
    DrawDataSet,
    undo,
    redo,
    clear,
    dataList,
    username,
    teacherUsername,
    userPermission,
    addBlock,
    setAddBlock,
    addComponent,
    toggleModal,
    screenData,
    selectionBoxRef,
    setSelectionBox,
    setGroupSelect,
    setAllIsOnLock,
    setContainerPosition,
    coverSetting,
    CoverDataSet,
    receive,
    handleReceive,
    toolScale,
    spotlightSize,
    setSpotlightSize,
    cursorSetColor,
    selectCleanForCursor,
    socketRequest,
  } = props;
  const rangeRef: any = React.useRef<Range>();
  const [openSmallList, setOpenSmallList] = useState<boolean>(false);
  const [toolList, setToolList] = useState<any>([
    // 多媒體
    { title: "圖片", type: "WIDGET_IMAGE", image: widgetImage, count: 0 },
    { title: "寫字", type: "WIDGET_TEXT", image: widgetText, count: 0 },
    { title: "閱讀器", type: "WIDGET_READ", image: widgetRead, count: 0 },
    { title: "影片", type: "WIDGET_VIDEO_TIMELINE", image: widgetVideoTimeline, count: 0 },
    { title: "超連結", type: "WIDGET_HYPERLINK", image: widgetHyperlink, count: 0 },
    { title: "二維碼", type: "WIDGET_QR_CODE", image: widgetQrCode, count: 0 },
    { title: "代碼", type: "WIDGET_EMBED", image: widgetEmbed, count: 0 },

    // 班級互動
    { title: "分組", type: "WIDGET_GROUP_MAKER", image: widgetGroupMaker, count: 0 },
    { title: "抽籤", type: "WIDGET_RANDOM_NAME", image: widgetRandomName, count: 0 },
    { title: "翻卡片", type: "WIDGET_CARD", image: widgetCard, count: 0 },
    { title: "心智圖", type: "WIDGET_MIND_MAP", image: widgetMindMap, count: 0 },
    { title: "作業", type: "WIDGET_WORKS", image: widgetWorks, count: 0 },

    // 時間工具
    { title: "日曆", type: "WIDGET_CALENDAR", image: widgetCalendar, count: 0 },
    { title: "倒數器", type: "WIDGET_EVENT_COUNTDOWN", image: widgetEventCountdown, count: 0 },
    { title: "時程表", type: "WIDGET_TIMETABLE", image: widgetTimeTable, count: 0 },
    { title: "時鐘", type: "WIDGET_CLOCK", image: widgetClock, count: 0 },
    { title: "計時器", type: "WIDGET_TIMER", image: widgetTimer, count: 0 },
    { title: "碼錶", type: "WIDGET_STOPWATCH", image: widgetStopwatch, count: 0 },
  ]);
  const [toolIndex, setToolIndex] = useState<number>(0);

  function updateCounts(arrA: any, arrB: any) {
    const arrayA = Array.from(arrA);
    const arrayB = Array.from(arrB);
    const typeCounts: any = {};
    arrayB.forEach((item: any) => {
      const { type, studentName } = item;
      if (teacherUsername && !studentName) {
        typeCounts[type] = (typeCounts[type] || 0) + 1;
      } else if (username && studentName && (username === studentName))  {
        typeCounts[type] = (typeCounts[type] || 0) + 1;
      }
    });
    arrayA.forEach((item: any) => {
      const { type } = item;
      item.count = typeCounts[type] || 0;
    });
    return arrayA;
  }

  const openSmall = () => {
    setOpenSmallList(!openSmallList);
  };

  useEffect(() => {
    const newTools = updateCounts(toolList, dataList);
    setToolList(newTools);
  }, [dataList]);

  useEffect(() => {
    const app = document.getElementById("app");
      if (app) {
        if (receive || username && !userPermission) {
          if (app.classList.contains("btm-tool-hide")) {
            app.classList.remove("btm-tool-hide");
          } else {
            app.classList.add("btm-tool-hide");
          }
        }
      }
  }, [receive, userPermission]);

  const toLeft = () => {
    if (toolIndex === 0) {
      setToolIndex(2);
    } else {
      setToolIndex(toolIndex - 1);
    }
  };
  const toRight = () => {
    if (toolIndex === 2) {
      setToolIndex(0);
    } else {
      setToolIndex(toolIndex + 1);
    }
  };

  const handleRangeChange = (newValues: any) => {
    if (newValues[0] >= 0) {
      setSpotlightSize(newValues[0]);
    }
  };

  const sendSettingsToSocket = (type: string) => {
      (async () => {
          const response = await socketRequest("updateBoard", {
            coverData: {
              type: type,
            }
          });
          // console.log(response);
        }) ();
    };

  const sendUserToolToSocket = (tool: string) => {
      (async () => {
          const response = await socketRequest("updateBoard", {
            coverData: {
              tool: tool,
            }
          });
          // console.log(response);
        }) ();
    };

  return (
    <React.Fragment>
      <Tooltip anchorSelect=".tool-anchor" place="top" />
      <div className={`btn-toolBar absolute w-100 z-5 ${ screenData.screenWidth < 768? "mb-toolbar" : "" }`} style={{ transform: `scale(${ toolScale }) translateX(-50%)` }}>
        {toolSwitch === "draw"? (
          <div className={`pattern-tool ${ receive? "receive-draw" : "" } ${drawSetting.mode === "pattern"? "active" : ""}`}>
            <div className={`tool-anchor tool-pattern ${drawSetting.type === "line"? "active" : ""}`} onClick={() => DrawDataSet({ type: "line" })} data-tooltip-content="線條">
              <img src={line} alt="" style={{ height: "24px", width: "15px" }} />
            </div>
            <div className={`tool-anchor tool-pattern ${drawSetting.type === "arrow"? "active" : ""}`} onClick={() => DrawDataSet({ type: "arrow" })} data-tooltip-content="箭頭">
              <img src={arrow} alt="" style={{ height: "24px", width: "15px" }} />
            </div>
            <div className={`tool-anchor tool-pattern ${drawSetting.type === "rect"? "active" : ""}`} onClick={() => DrawDataSet({ type: "rect" })} data-tooltip-content="長方形">
              <img src={rect} alt="" style={{ height: "30px", width: "20px" }} />
            </div>
            <div className={`tool-anchor tool-pattern ${drawSetting.type === "ellipse"? "active" : ""}`} onClick={() => DrawDataSet({ type: "ellipse" })} data-tooltip-content="橢圓">
              <img src={ellipse} alt="" style={{ height: "30px", width: "20px" }} />
            </div>
            <div className={`tool-anchor tool-pattern ${drawSetting.type === "rectFill"? "active" : ""}`} onClick={() => DrawDataSet({ type: "rectFill" })} data-tooltip-content="長方形（實心）">
              <img src={rectFill} alt="" style={{ height: "30px", width: "20px" }} />
            </div>
            <div className={`tool-anchor tool-pattern ${drawSetting.type === "ellipseFill"? "active" : ""}`} onClick={() => DrawDataSet({ type: "ellipseFill" })} data-tooltip-content="橢圓（實心）">
              <img src={ellipseFill} alt="" style={{ height: "30px", width: "20px" }} />
            </div>
          </div>
        ) : null}
        <div className="flex flex-row items-center justify-center pb-0">
          <div className={`btn-card text-gray-800 ${username? "userside" : ""} ${receive? "receive-list" : ""}`}>
            <div className="flex flex-row overflow-hidden">
              {teacherUsername? (
                <div className="tool-switch">
                  <Button
                    type="button"
                    className={`switch-btn cursor-switch ${toolSwitch === "cursor"? "active" : ""}`}
                    onClick={() => {switchToggle("cursor"); sendUserToolToSocket("cursor")}}
                  >
                    <img src={btnCursor} alt="" />
                  </Button>
                  <Button
                    type="button"
                    className={`switch-btn draw-switch ${toolSwitch === "draw"? "active" : ""}`}
                    onClick={() => {switchToggle("draw"); sendUserToolToSocket("draw")}}
                  >
                    <img src={btnDraw} alt="" />
                  </Button>
                  <Button
                    type="button"
                    className={`switch-btn searchlight-switch ${toolSwitch === "searchlight"? "active" : ""}`}
                    onClick={() => {switchToggle("searchlight"); sendUserToolToSocket("searchlight")}}
                  >
                    <img src={btnSearchlight} alt="" />
                  </Button>
                </div>
              ) : null}
              {toolSwitch === "draw"? (
                <>
                  <div className="draw-tool">
                    <div className={`tool-anchor draw-btn ${drawSetting.mode === "grab"? "active" : ""}`} onClick={() => {DrawDataSet({ mode: "grab" }); jobToggle("grab");}} data-tooltip-content="抓取">
                      <img src={grab} alt="" style={{ width: "36px" }} />
                    </div>
                    <div className={`tool-anchor draw-btn ${drawSetting.mode === "pencil"? "active" : ""}`} onClick={() => {DrawDataSet({ mode: "pencil" }); jobToggle("draw"); selectCleanForCursor();}} data-tooltip-content="鉛筆">
                      <img src={pencil} alt="" style={{ width: "36px" }} />
                    </div>
                    <div className={`tool-anchor draw-btn ${drawSetting.mode === "highlighter"? "active" : ""}`} onClick={() => {DrawDataSet({ mode: "highlighter" }); jobToggle("draw"); selectCleanForCursor();}} data-tooltip-content="螢光筆">
                      <img src={highlighter} alt="" style={{ width: "36px" }} />
                    </div>
                    <div className={`tool-anchor draw-btn ${drawSetting.mode === "pattern"? "active" : ""}`} onClick={() => {DrawDataSet({ mode: "pattern" }); jobToggle("draw"); selectCleanForCursor();}} data-tooltip-content="圖形">
                      <img src={pattern} alt="" style={{ width: "36px" }} />
                    </div>
                    <div
                      className={`tool-anchor draw-btn ${drawSetting.mode === "eraser"? "active" : ""}`}
                      onClick={() => {
                        DrawDataSet({ mode: "eraser" });
                        jobToggle("eraser");
                        if (selectionBoxRef.current) {
                          selectionBoxRef.current = null;
                        }
                        setSelectionBox(null);
                        setGroupSelect(false);
                        setAllIsOnLock(false);
                        setContainerPosition(null);
                      }}
                      data-tooltip-content="橡皮擦"
                    >
                      <img src={eraser} alt="" style={{ width: "36px" }} />
                    </div>
                  </div>
                  <div className={`tool-settings ${openSmallList? "show" : ""}`}>
                    <div className="right-tool">
                      {/* <div className="steps-tool">
                        <div className="tool-anchor tool-step" onClick={() => undo()} data-tooltip-content="上一步">
                          <img src={turnLeft} alt="" style={{ width: "19px" }} />
                        </div>
                        <div className="tool-anchor tool-step" onClick={() => redo()} data-tooltip-content="下一步">
                          <img src={turnRight} alt="" style={{ width: "19px" }} />
                        </div>
                        <div className="tool-anchor tool-step" onClick={() => clear()} data-tooltip-content="清空">
                          <img src={Delete} alt="" style={{ width: "24px" }} />
                        </div>
                      </div> */}
                      <div className="size-tool">
                        <div className={`tool-size ${drawSetting.size === 3? "active" : ""}`} style={{ "--toolSize": "3px" }} onClick={() => DrawDataSet({ size: 3 })}>
                          <div></div>
                        </div>
                        <div className={`tool-size ${drawSetting.size === 9? "active" : ""}`} style={{ "--toolSize": "6px" }} onClick={() => DrawDataSet({ size: 9 })}>
                          <div></div>
                        </div>
                        <div className={`tool-size ${drawSetting.size === 27? "active" : ""}`} style={{ "--toolSize": "10px" }} onClick={() => DrawDataSet({ size: 27 })}>
                          <div></div>
                        </div>
                      </div>
                    </div>
                    <div className="color-tool">
                      <div
                        className={`tool-color-1 ${drawSetting.color === "#111827"? "active" : ""}`}
                        style={{ "--toolColor": "#111827" }}
                        onClick={() => {
                          console.log('drawSetting.mode', drawSetting.mode);
                          
                          if (drawSetting.mode === "grab") {
                            cursorSetColor("#111827");
                            DrawDataSet({ color: "#111827" });
                          } else {
                            DrawDataSet({ color: "#111827", mode: "pencil" })
                          }
                        }}
                      >
                        <div></div>
                      </div>
                      <div
                        className={`tool-color-2 ${drawSetting.color === "#ffffff"? "active" : ""}`}
                        style={{ "--toolColor": "#ffffff" }}
                        onClick={() => {
                          if (drawSetting.mode === "grab") {
                            cursorSetColor("#ffffff");
                            DrawDataSet({ color: "#ffffff" });
                          } else {
                            DrawDataSet({ color: "#ffffff", mode: "pencil" })
                          }
                        }}
                      >
                        <div></div>
                      </div>
                      <div
                        className={`tool-color-3 ${drawSetting.color === "#eb3737"? "active" : ""}`}
                        style={{ "--toolColor": "#eb3737" }}
                        onClick={() => {
                          if (drawSetting.mode === "grab") {
                            cursorSetColor("#eb3737");
                            DrawDataSet({ color: "#eb3737" });
                          } else {
                            DrawDataSet({ color: "#eb3737", mode: "pencil" })
                          }
                        }}
                      >
                        <div></div>
                      </div>
                      <div
                        className={`tool-color-4 ${drawSetting.color === "#2563eb"? "active" : ""}`}
                        style={{ "--toolColor": "#2563eb" }}
                        onClick={() => {
                          if (drawSetting.mode === "grab") {
                            cursorSetColor("#2563eb");
                            DrawDataSet({ color: "#2563eb" });
                          } else {
                            DrawDataSet({ color: "#2563eb", mode: "pencil" })
                          }
                        }}
                      >
                        <div></div>
                      </div>
                      <div
                        className={`tool-color-5 ${drawSetting.color === "#f97316"? "active" : ""}`}
                        style={{ "--toolColor": "#f97316" }}
                        onClick={() => {
                          if (drawSetting.mode === "grab") {
                            cursorSetColor("#f97316");
                            DrawDataSet({ color: "#f97316" });
                          } else {
                            DrawDataSet({ color: "#f97316", mode: "pencil" })
                          }
                        }}
                      >
                        <div></div>
                      </div>
                      <div
                        className={`tool-color-6 ${drawSetting.color === "#38bdf8"? "active" : ""}`}
                        style={{ "--toolColor": "#38bdf8" }}
                        onClick={() => {
                          if (drawSetting.mode === "grab") {
                            cursorSetColor("#38bdf8");
                            DrawDataSet({ color: "#38bdf8" });
                          } else {
                            DrawDataSet({ color: "#38bdf8", mode: "pencil" })
                          }
                        }}
                      >
                        <div></div>
                      </div>
                      <div
                        className={`tool-color-7 ${drawSetting.color === "#facc15"? "active" : ""}`}
                        style={{ "--toolColor": "#facc15" }}
                        onClick={() => {
                          if (drawSetting.mode === "grab") {
                            cursorSetColor("#facc15");
                            DrawDataSet({ color: "#facc15" });
                          } else {
                            DrawDataSet({ color: "#facc15", mode: "pencil" })
                          }
                        }}
                      >
                        <div></div>
                      </div>
                      <div
                        className={`tool-color-8 ${drawSetting.color === "#9333ea"? "active" : ""}`}
                        style={{ "--toolColor": "#9333ea" }}
                        onClick={() => {
                          if (drawSetting.mode === "grab") {
                            cursorSetColor("#9333ea");
                            DrawDataSet({ color: "#9333ea" });
                          } else {
                            DrawDataSet({ color: "#9333ea", mode: "pencil" })
                          }
                        }}
                      >
                        <div></div>
                      </div>
                      <div
                        className={`tool-color-9 ${drawSetting.color === "#22c55e"? "active" : ""}`}
                        style={{ "--toolColor": "#22c55e" }}
                        onClick={() => {
                          if (drawSetting.mode === "grab") {
                            cursorSetColor("#22c55e");
                            DrawDataSet({ color: "#22c55e" });
                          } else {
                            DrawDataSet({ color: "#22c55e", mode: "pencil" })
                          }
                        }}
                      >
                        <div></div>
                      </div>
                      <div
                        className={`tool-color-10 ${drawSetting.color === "#ff52ac"? "active" : ""}`}
                        style={{ "--toolColor": "#ff52ac" }}
                        onClick={() => {
                          if (drawSetting.mode === "grab") {
                            cursorSetColor("#ff52ac");
                            DrawDataSet({ color: "#ff52ac" });
                          } else {
                            DrawDataSet({ color: "#ff52ac", mode: "pencil" })
                          }
                        }}
                      >
                        <div></div>
                      </div>
                    </div>
                  </div>
                  <div className="btn-close-open">
                    <button className={`top-tool-btn receive-btn ${receive? "lowerArrow" : "upperArrow"}`} onClick={handleReceive}>
                      {receive? (
                        <img src={openBottom} alt="" />
                      ) : (
                        <img src={closeBottom} alt="" />
                      )}
                    </button>
                  </div>
                </>
              ) : toolSwitch === "cursor"? (
                <div className="w-100 overflow-hidden toolBtns">
                  <div className="flex flex-row overflow-hidden">
                    <div className="flex flex-row btn-tools">
                      {/*  */}
                      {teacherUsername? (
                        <>
                          <div
                            className="tool-left-switch"
                            onClick={() => {
                              toLeft();
                            }}
                          >
                            <img src={toolLeft} alt="" />
                          </div>
                          <div className={`tool-multimediae ${ toolIndex === 0? "show-tool" : ""}`}>
                            <div className="btn-tool">
                              <Button 
                                type="button"
                                className="widget-btn relative"
                                onClick={() => toggleModal()}
                              >
                                <img src={widgetBackground} alt="" />
                              </Button>
                              <div className="btn-title overflow-hidden transition-[height]">
                                <p className="w-full overflow-hidden text-ellipsis break-words text-center font-semibold transition-[font-size]">
                                  <span>{"背景"}</span>
                                </p>
                              </div>
                            </div>
                            {(toolList || []).map((item: any, key: any) => (
                              (key === 0 || key === 1 || key === 2 || key === 3 || key === 4 || key === 5 || key === 6) && (
                                <div className="btn-tool" key={key}>
                                  <Button
                                    type="button"
                                    className={`widget-btn relative ${item.type}`}
                                    onClick={() => {addComponent(item.type); setAddBlock(true);}}
                                    disabled={addBlock}
                                  >
                                    {item.count > 0? (
                                      <span className="miniCount position-absolute">{item.count > 9? "9+" : item.count}</span>
                                    ) : null}
                                    {!addBlock? (
                                    <img src={item.image} alt="" />
                                    ) : (
                                      <span className="ts-load d-flex justify-center items-center">
                                        <Spinner size="sm" className="flex-shrink-0"> Loading... </Spinner>
                                      </span>
                                    )}
                                  </Button>
                                  <div className="btn-title overflow-hidden transition-[height]">
                                    <p className="w-full overflow-hidden text-ellipsis break-words text-center font-semibold transition-[font-size]">
                                      <span>{item.title}</span>
                                    </p>
                                  </div>
                                </div>
                              )
                            ))}
                          </div>
                          <div className={`tool-classe ${ toolIndex === 1? "show-tool" : ""}`}>
                            {(toolList || []).map((item: any, key: any) => (
                              (key === 7 || key === 8 || key === 9 || key === 10 || key === 11) && (
                                <div className="btn-tool" key={key}>
                                  <Button
                                    type="button"
                                    className={`widget-btn relative ${item.type}`}
                                    onClick={() => {addComponent(item.type); setAddBlock(true);}}
                                    disabled={addBlock}
                                  >
                                    {item.count > 0? (
                                      <span className="miniCount position-absolute">{item.count > 9? "9+" : item.count}</span>
                                    ) : null}
                                    {!addBlock? (
                                    <img src={item.image} alt="" />
                                    ) : (
                                      <span className="ts-load d-flex justify-center items-center">
                                        <Spinner size="sm" className="flex-shrink-0"> Loading... </Spinner>
                                      </span>
                                    )}
                                  </Button>
                                  <div className="btn-title overflow-hidden transition-[height]">
                                    <p className="w-full overflow-hidden text-ellipsis break-words text-center font-semibold transition-[font-size]">
                                      <span>{item.title}</span>
                                    </p>
                                  </div>
                                </div>
                              )
                            ))}
                          </div>
                          <div className={`tool-timee ${ toolIndex === 2? "show-tool" : ""}`}>
                            {(toolList || []).map((item: any, key: any) => (
                              (key === 12 || key === 13 || key === 14 || key === 15 || key === 16 || key === 17) && (
                                <div className="btn-tool" key={key}>
                                  <Button
                                    type="button"
                                    className={`widget-btn relative ${item.type}`}
                                    onClick={() => {addComponent(item.type); setAddBlock(true);}}
                                    disabled={addBlock}
                                  >
                                    {item.count > 0? (
                                      <span className="miniCount position-absolute">{item.count > 9? "9+" : item.count}</span>
                                    ) : null}
                                    {!addBlock? (
                                    <img src={item.image} alt="" />
                                    ) : (
                                      <span className="ts-load d-flex justify-center items-center">
                                        <Spinner size="sm" className="flex-shrink-0"> Loading... </Spinner>
                                      </span>
                                    )}
                                  </Button>
                                  <div className="btn-title overflow-hidden transition-[height]">
                                    <p className="w-full overflow-hidden text-ellipsis break-words text-center font-semibold transition-[font-size]">
                                      <span>{item.title}</span>
                                    </p>
                                  </div>
                                </div>
                              )
                            ))}
                          </div>
                          <div
                            className="tool-right-switch"
                            onClick={() => {
                              toRight();
                            }}
                          >
                            <img src={toolRight} alt="" />
                          </div>
                        </>
                      ) : null}
                      {!teacherUsername? (
                        <React.Fragment>
                          {(toolList || []).map((item: any, key: any) => (
                            (item.type === "WIDGET_IMAGE" || item.type === "WIDGET_TEXT" || item.type === "WIDGET_DRAW" || item.type === "WIDGET_EMBED" || item.type === "WIDGET_HYPERLINK") && (
                              <div className="btn-tool" key={key}>
                                <Button
                                  type="button"
                                  className={`widget-btn relative ${item.type}`}
                                  onClick={() => {addComponent(item.type); setAddBlock(true);}}
                                  disabled={addBlock}
                                >
                                  {item.count > 0? (
                                    <span className="miniCount position-absolute">{item.count}</span>
                                  ) : null}
                                  <img src={item.image} alt="" />
                                </Button>
                                <div className="btn-title overflow-hidden transition-[height]">
                                  <p className="w-full overflow-hidden text-ellipsis break-words text-center font-semibold transition-[font-size]">
                                    <span>{item.title}</span>
                                  </p>
                                </div>
                              </div>
                            )
                          ))}
                        </React.Fragment>
                      ) : null}
                      {/*  */}
                    </div>
                    <div className="btn-close-open">
                      <button className={`top-tool-btn receive-btn ${receive? "lowerArrow" : "upperArrow"}`} onClick={handleReceive}>
                        {receive? (
                          <img src={openBottom} alt="" />
                        ) : (
                          <img src={closeBottom} alt="" />
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <div className="draw-tool">
                    <div
                      className={`tool-anchor draw-btn ${coverSetting.type === "circle"? "active" : ""}`}
                      onClick={() => {
                        CoverDataSet({ type: "circle" });
                        selectCleanForCursor();
                        sendSettingsToSocket("circle");
                      }}
                      data-tooltip-content="圓形"
                    >
                      <img src={coverCircle} alt="" style={{ width: "36px" }} />
                    </div>
                    <div
                      className={`tool-anchor draw-btn ${coverSetting.type === "strip"? "active" : ""}`}
                      onClick={() => {
                        CoverDataSet({ type: "strip" });
                        selectCleanForCursor();
                        sendSettingsToSocket("strip");
                      }}
                      data-tooltip-content="線"
                    >
                      <img src={coverLine} alt="" style={{ width: "36px" }} />
                    </div>
                    <div
                      className={`tool-anchor draw-btn ${coverSetting.type === "square"? "active" : ""}`}
                      onClick={() => {
                        CoverDataSet({ type: "square" });
                        selectCleanForCursor();
                        sendSettingsToSocket("square");
                      }}
                      data-tooltip-content="方形"
                    >
                      <img src={coverRect} alt="" style={{ width: "36px" }} />
                    </div>
                  </div>
                  <div className={`tool-settings`}>
                    <div className="spotlight-size-tool">
                      <img src={toolSize} alt="" style={{ width: "24px" }} />
                      <div className="spotlight-size-bar">
                        {/* <div className="spotlight-bg"></div> */}
                        <Range
                          ref={rangeRef}
                          values={[spotlightSize]}
                          step={1}
                          min={0}
                          max={120}
                          onChange={handleRangeChange}
                          renderTrack={({ props, children }) => (
                            <div
                              onMouseDown={props.onMouseDown}
                              onTouchStart={props.onTouchStart}
                              style={{
                                height: "100%",
                                width: "100%",
                                display: "flex",
                                position: "relative",
                                borderRadius: "50px"
                              }}
                            >
                              <div className="spotlight-bg"></div>
                              <div
                                ref={props.ref}
                                style={{
                                  height: "100%",
                                  width: "100%",
                                  background: getTrackBackground({
                                    values: [spotlightSize],
                                    colors: ["#bae8da", "transparent"],
                                    min: 0,
                                    max: 120
                                  }),
                                  alignSelf: "center",
                                  borderRadius: "50px",
                                  position: "absolute",
                                  zIndex: 2,
                                }}
                              >
                                {children}
                              </div>
                            </div>
                          )}
                          renderThumb={({ props, index, isDragged }) => (
                            <div
                              {...props}
                              className="spotlightSliderBtn"
                              style={{
                                ...props.style,
                                height: "30px",
                                width: "30px",
                                backgroundColor: "#5DAF97",
                                border: "5px solid #ffffff",
                                borderRadius: "50%",
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                left: `${(props['aria-valuenow'] / 120) * 100}%`,
                                boxShadow: "0px 0px 2px 1px #00000040 inset, 0px 1px 2px 1px #00000040",
                                cursor: "grab",
                              }}
                            >
                            </div>
                          )}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="draw-tool">
                    <div
                      className={`tool-anchor draw-btn reverse-btn ${coverSetting.mode === "reverse"? "active" : ""}`}
                      onClick={() => {
                        if (coverSetting.mode === "reverse") {
                          CoverDataSet({ mode: "forward" });
                        } else {
                          CoverDataSet({ mode: "reverse" });
                        }
                      }}
                      data-tooltip-content="反轉"
                    >
                      <img src={coverReverse} alt="" style={{ width: "36px" }} />
                    </div>
                  </div>
                  <div className="btn-close-open">
                    <button className={`top-tool-btn receive-btn ${receive? "lowerArrow" : "upperArrow"}`} onClick={handleReceive}>
                      {receive? (
                        <img src={openBottom} alt="" />
                      ) : (
                        <img src={closeBottom} alt="" />
                      )}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BottomToolbar;